import { createTheme } from "@mui/material/styles";

// default colors
export const colors = {
    background: "#465362",
    primary: "#E0BE36",
    secondary: "#D45113",
};

// Create a theme instance.
export const theme = createTheme({
    palette: {
        primary: {
            main: colors.primary,
        },
        secondary: {
            main: colors.secondary,
        },
    },
});

export const darkTheme = createTheme({
    palette: {
        mode: "dark",
        primary: {
            main: colors.primary,
        },
        secondary: {
            main: colors.secondary,
        },
    },
});
